import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import About from "./pages/About/AboutUs";
import Contact from "./pages/Contact/Contact";
import Login from "./pages/Login/Login";
import Checkout from "./pages/Checkouts/Checkout";
import Payment from "./Components/StripeWrapper";
import Hostseminar from "./pages/Hostseminar/Hostseminar";
import Eventdetails from "./pages/Eventdetails/Eventdetails";
import Eventslist from "./pages/Eventslist/Eventlist";
import EventslistAll from "./pages/Eventslist/EventlistAll";
import Categorie from "./pages/Categorie/Categorie";
import Privacy from "./pages/Privacy";
import TermsAndConditions from "./pages/TermsAndConditions";
import ForgotPassword from "./pages/Login/ForgotPassword";
import AllDownloads from "./pages/downloads/AllDownloads";

function App() {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/categorie" element={<Categorie />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/Payment" element={<Payment />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/eventslist" element={<Eventslist />} />
        <Route path="/eventslistall" element={<EventslistAll />} />
        <Route path="/seminar" element={<Hostseminar />} />
        <Route path="/eventdetails/:id" element={<Eventdetails />} />
        <Route path="/events" element={<Categorie />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/resources" element={<AllDownloads />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
